import React, { createContext, useState } from "react";

export const languageOptions = {
  en: "text_en",
  sq: "text_sq",
};

export const LanguageContext = createContext({
  userLanguage: "sq",
});

export const LanguageProvider = ({ children }) => {
  const [userLanguage, setUserLanguage] = useState(
    (typeof window !== "undefined" &&
      window.localStorage.getItem("fibank-language")) ||
      "sq"
  );

  const provider = {
    userLanguage,
    changeUserLanguage: (selected) => {
      setUserLanguage(selected);
      const newLangauge = languageOptions[selected] ? selected : "sq";
      typeof window !== "undefined" &&
        window.localStorage.setItem("fibank-language", newLangauge);
    },
  };

  return (
    <LanguageContext.Provider value={provider}>
      {children}
    </LanguageContext.Provider>
  );
};

export const text = (data, userLanguage) => {
  if (!data) {
    return "";
  }
  return data[languageOptions[userLanguage]] || data[languageOptions["sq"]];
};
